import React from 'react';
import { ReactComponent as Logo } from '../assets/Icons/logo.svg';
import { Link } from 'react-router-dom';

import {
  ADDRESS_LINES,
  PHONE,
  PRIVACY_POLICY_URL,
  TERMS_OF_USE_URL,
} from './footerLinks';

export const Footer = () => {
  return (
    <footer className="px-6 py-10 sm:px-10 sm:py-12 bg-background-secondary text-white">
      <div className="max-w-screen-2xl mx-auto">
        <div className="max-w-7xl mx-auto flex justify-between flex-wrap gap-8">
          <div className="space-y-6">
            <Logo className="h-14 text-sm" />
          </div>
          <div className="space-y-6 text-sm font-semibold">
            <p>
              <Link
                to="https://frontiertech.edu/catalog/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Catalog
              </Link>
            </p>
            <p>
              <Link
                to={'https://frontiertech.edu/requirements-policies/'}
                target="_blank"
                rel="noopener noreferrer"
              >
                Admissions
              </Link>
            </p>
          </div>
          <div className="space-y-6 text-sm font-semibold">
            <p>
              <Link
                to={'https://www.frontiertech.edu/accreditation-licensure'}
                target="_blank"
                rel="noopener noreferrer"
              >
                Accreditation
              </Link>
            </p>
            {/*<p>
              <Link
                to={'https://www.frontiertech.edu/mission-goals'}
                target="_blank"
                rel="noopener noreferrer"
              >
                Mission & History
              </Link>
            </p>*/}
            <p>
              <Link
                to={'https://www.frontiertech.edu/contact-us'}
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Us
              </Link>
            </p>
          </div>
          <div className="space-y-6 text-md font-semibold">
            <p>Connect</p>
            <div className="font-normal">
              {ADDRESS_LINES.map((line) => (
                <p key={line}>{line}</p>
              ))}
            </div>
            <Link to={PHONE.href} className="underline font-normal">
              {PHONE.label}
            </Link>
          </div>
        </div>
        <div className="border-t border-white/50 mt-10 pt-4 flex flex-col md:flex-row justify-between items-start md:items-center text-white/80 text-xs">
          <p>
            Accredited by the{' '}
            <span className="font-semibold text-white">
              Distance Education Accrediting Commission (DEAC)
            </span>
          </p>
          <p>
            Copyright © {new Date().getFullYear()} Frontier Institute of
            Technology &nbsp;|&nbsp;
            <Link
              to={PRIVACY_POLICY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              Privacy Policy
            </Link>
            &nbsp;|&nbsp;
            <Link
              to={TERMS_OF_USE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              Terms of Use
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};
